module.exports = __webpack_public_path__ + "static/media/enterprise_pilot_plus-registration_success.c621e453.svg";